<div class="chart-detail-header">
  @if (icon(); as iconValue) {
    @if (iconValue) {
      <img class="chart-detail-icon" [src]="'assets/img/icons/color-icons/' + iconValue + '.svg'" [alt]="" />
    }
  }
  <h2 class="chart-detail-title">{{ name() }}</h2>
</div>

<div class="chart-detail-meter" [style.--progress-stroke]="progressColor()">
  <svg viewBox="0 0 80 80">
    <circle class="track" cx="40" cy="40" r="36" />
    <circle
      class="progress"
      cx="40"
      cy="40"
      r="36"
      transform="rotate(-90 40 40)"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="dashOffset()"
    />
  </svg>
  <div class="chart-values">
    <span class="meter-percent">{{ percentComplete() }}%</span>
  </div>
</div>

@if (currentValueDisplay() && targetValueDisplay()) {
  <div class="chart-current-value">{{ currentValueDisplay() }} / {{ targetValueDisplay() }}</div>
}
